import { render } from "./TheModalForm.vue?vue&type=template&id=fb1ed2c6&scoped=true&lang=pug&bindings={\"id\":\"props\",\"contacts\":\"setup\",\"address\":\"setup\",\"title\":\"setup\",\"titleText\":\"setup\"}"
import script from "./TheModalForm.vue?vue&type=script&lang=js"
export * from "./TheModalForm.vue?vue&type=script&lang=js"

import "./TheModalForm.vue?vue&type=style&index=0&id=fb1ed2c6&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb1ed2c6"

export default script